/**
 * Recharts Tooltip wrapper for composable report charts.
 * Bridges Recharts' <Tooltip> API to the generic ReportWidgetTooltip renderer.
 */
import { ReportWidgetTooltip } from './ReportWidgetTooltip';

import type {
    ReportWidgetItem,
    ReportWidgetTooltipRowsBuilder,
} from '../../model/types';
import type { TooltipProps } from 'recharts';

export interface ReportWidgetChartTooltipProps
    extends TooltipProps<number, string> {
    total: number;
    items: ReportWidgetItem[];
    tooltipFormatter: (value: number) => string;
    tooltipRowsBuilder?: ReportWidgetTooltipRowsBuilder;
}

export function ReportWidgetChartTooltip({
    active,
    payload,
    label,
    tooltipFormatter,
    total,
    items,
    tooltipRowsBuilder,
}: Readonly<ReportWidgetChartTooltipProps>) {
    return (
        <ReportWidgetTooltip
            active={active}
            payload={payload}
            label={label}
            total={total}
            items={items}
            tooltipFormatter={tooltipFormatter}
            tooltipRowsBuilder={tooltipRowsBuilder}
        />
    );
}
